export default __webpack_public_path__ + "static/media/008-cups.6a2e4675.png";